import { useTranslation } from 'react-i18next'

import { InstalledConnection } from 'app/connections/types'

import styles from './Connection.module.scss'
import ConnectionIcon from './ConnectionIcon'

interface ConnectionComponentProps {
  className?: string
  iconSize?: number
  connection: InstalledConnection | null
}
const ConnectionComponent = ({
  className,
  iconSize = 24,
  connection,
}: ConnectionComponentProps) => {
  const { t } = useTranslation('connections')

  return connection ? (
    <div className={[styles.connection, className].join(' ')}>
      <div style={{ width: iconSize }}></div>
      <ConnectionIcon style={{ height: iconSize, width: iconSize }} connection={connection} />
      {t(`available.${connection.name}.displayName`)}
    </div>
  ) : (
    '-'
  )
}

export default ConnectionComponent
